<template>
  <div style="padding:10px;">
    <!--v-row>
      <v-col
        cols="12"
        class="py-2"
      >
        <h2>Animadores</h2>
      </v-col>
    </v-row-->
    <v-row v-if="contentTypeID">
      <v-col
        cols="8"
        class="py-2"
      >
        <list
          :locale="locale"
          :onEdit="(v) => { editedItem = JSON.parse(JSON.stringify(v)) }"
          :forceRefresh="forceRefresh"
          :contentTypeID="contentTypeID"
        />
      </v-col>
      <v-col
        cols="4"
        class="py-2"
      >
        <entertainers-form
          :value="editedItem"
          :locale="locale"
          :onClose="handleCloseForm"
          :languages="languages"
          :contentTypeID="contentTypeID"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import List from './List'
import EntertainersForm from './Form'
export default {
  components: {
    List,
    EntertainersForm,
  },
  data: () => ({
    editedItem: null,
    forceRefresh: null,
    languages: null,
    contentTypeID: null,
  }),
  computed: {
    ...mapState('app',['locale', 'dviewcontentWorkspace']),
    workspaceID () {
      return this.dviewcontentWorkspace
    },
  },
  watch: {
    dviewcontentWorkspace () {
      this.handleGetConfig()
    },
    '$route.params.id' () {
      this.contentTypeID = this.$route.params.id
    },
  },
  mounted () {
    this.contentTypeID = this.$route.params.id
    this.handleGetConfig()
  },
  methods: {
    async handleGetConfig () {
      api.getItem('dviewcontent', `private/workspaces/`, this.workspaceID)
        .then((response) => {
          this.languages = response.Languages ? JSON.parse(response.Languages) : []
        })
    },
    handleCloseForm (refresh) {
      if (refresh) this.forceRefresh = new Date().toISOString()
      this.editedItem = null
    },
  }
}
</script>

